import { Box, Flex, Spacer } from '@chakra-ui/react';
import { STOCK_UI } from '@diamond/shared/decimal-util-web';
import { Text } from '@diamond/shared/ui';
import { numberWithSeparator } from '@diamond/shared/utils';
import { dinero, toDecimal } from 'dinero.js';
import { memo } from 'react';

import { Image } from '../../common';
import { ProductPreviewProps } from './types';

const ProductPreview = memo(({ data, isMobile }: ProductPreviewProps) => {
  const item = data.items[0];
  const productDesc =
    item?.desc.length > 45 && isMobile
      ? `${item?.desc.slice(0, 45)} ...`
      : item?.desc;

  const qtyFirstProduct = dinero({
    amount: Number(item.quantity),
    currency: STOCK_UI,
  });

  const formattedQuantity = numberWithSeparator(
    Number(toDecimal(qtyFirstProduct))
  );

  return (
    <Box w={{ base: 'full', md: '40%' }}>
      <Flex alignItems="center" gap="2" my="4">
        <Box position="relative" boxSize={{ base: 10, md: 20 }}>
          <Image
            src={item?.images_medium?.[0]}
            alt={item?.title}
            style={{ objectFit: 'scale-down' }}
            fill
          />
        </Box>
        <Box w={{ base: '210px', md: 'auto' }}>
          <Text
            fontWeight="bold"
            fontSize="sm"
            display={{ base: 'none', md: 'block' }}
          >
            {item?.brand_desc}
          </Text>
          <Text fontSize={{ base: 'xs', md: 'sm' }}>{productDesc}</Text>
          <Text fontSize={{ base: 'xs', md: 'sm' }} color="gray.75">
            {item?.item_code}
          </Text>
        </Box>
        <Spacer display={{ base: 'none', md: 'flex' }} />
        <Box>
          <Text fontSize={{ base: 'sm', md: 'lg' }}>x{formattedQuantity}</Text>
        </Box>
      </Flex>
    </Box>
  );
});

ProductPreview.displayName = 'ProductPreview';

export { ProductPreview };
